import React, { useState, useEffect } from 'react';
import { getLastResults, getDetailResults } from '@/services/casinoApi';
import "./Result.css";
import ResultModalLayout from '@/components/ResultModalLayout';

const getCardImage = (cardCode) => {
  if (!cardCode) return null;
  try {
    if (cardCode.length < 3) {
      return null;
    }
    return `/assets/img/cards/${cardCode}.png`;
  } catch (e) {
    return null;
  }
};

const parseCards = (cardString) => {
  if (!cardString) return { dragon: null, tiger: null };
  const cards = cardString.split(',');
  const dragonCard = cards[0] ? getCardImage(cards[0].trim()) : null;
  const tigerCard = cards[1] ? getCardImage(cards[1].trim()) : null;
  return { dragon: dragonCard, tiger: tigerCard };
};

const parseRdesc = (rdesc) => {
  if (!rdesc) return {};
  const parts = rdesc.split('#');
  const winner = parts[0] || "";
  const pair = parts[1] || "No";
  const oddEvenPart = parts[2] || "";
  const oddEvenMatch = oddEvenPart.match(/D\s*:\s*(\w+)\s*\|\s*T\s*:\s*(\w+)/);
  const dragonOddEven = oddEvenMatch ? oddEvenMatch[1].trim() : "";
  const tigerOddEven = oddEvenMatch ? oddEvenMatch[2].trim() : "";
  const colorPart = parts[3] || "";
  const colorMatch = colorPart.match(/D\s*:\s*(\w+)\s*\|\s*T\s*:\s*(\w+)/);
  const dragonColor = colorMatch ? colorMatch[1].trim() : "";
  const tigerColor = colorMatch ? colorMatch[2].trim() : "";
  const suitPart = parts[4] || "";
  const suitMatch = suitPart.match(/D\s*:\s*(\w+)\s*\|\s*T\s*:\s*(\w+)/);
  const dragonSuit = suitMatch ? suitMatch[1].trim() : "";
  const tigerSuit = suitMatch ? suitMatch[2].trim() : "";
  return {
    winner,
    pair,
    dragonOddEven,
    tigerOddEven,
    dragonColor,
    tigerColor,
    dragonSuit,
    tigerSuit,
  };
};

const ResultDragonTiger6 = ({ data = [], gameData = {} }) => {
  const [showModal, setShowModal] = useState(false);
  const [selectedResult, setSelectedResult] = useState(null);
  const [lastResults, setLastResults] = useState([]);
  const [detailResult, setDetailResult] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchLastResults = async () => {
      try {
        const response = await getLastResults('dt6');
        if (response?.success && response?.data?.data?.res) {
          const mappedResults = response.data.data.res.map(item => ({
            mid: item.mid,
            win: item.win === "1" ? "D" : item.win === "2" ? "T" : item.win
          }));
          setLastResults(mappedResults);
        }
      } catch (error) {
        console.error('Error fetching last results:', error);
      }
    };
    fetchLastResults();
    const interval = setInterval(fetchLastResults, 5000);
    return () => clearInterval(interval);
  }, []);

  const handleResultClick = async (resultItem, index) => {
    setSelectedResult(resultItem);
    setLoading(true);
    const mid = resultItem?.mid;
    if (mid) {
      try {
        const response = await getDetailResults('dt6', mid.toString());
        if (response?.success && response?.data?.data?.t1) {
          setDetailResult(response.data.data.t1);
        }
      } catch (error) {
        console.error('Error fetching detail results:', error);
      }
    }
    setLoading(false);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedResult(null);
    setDetailResult(null);
  };

  const getModalData = () => {
    if (!selectedResult || !detailResult) return null;
    const cards = parseCards(detailResult.card);
    const rdescData = parseRdesc(detailResult.rdesc);
    const winner = detailResult.winnat || rdescData.winner || "";
    const winValue = detailResult.win;
    const isDragonWinner = winValue === "1" || winner.toLowerCase() === "dragon";
    const isTigerWinner = winValue === "2" || winner.toLowerCase() === "tiger";
    return {
      roundId: detailResult.rid || gameData?.data?.data?.mid || gameData?.mid || "N/A",
      matchTime: detailResult.mtime || gameData?.data?.data?.mt || new Date().toLocaleString(),
      dragon: {
        card: cards.dragon,
        isWinner: isDragonWinner,
      },
      tiger: {
        card: cards.tiger,
        isWinner: isTigerWinner,
      },
      resultDetails: {
        winner: winner,
        pair: rdescData.pair || "No",
        oddEven: `D : ${rdescData.dragonOddEven}  |  T : ${rdescData.tigerOddEven}`,
        color: `D : ${rdescData.dragonColor}  |  T : ${rdescData.tigerColor}`,
        suit: `D : ${rdescData.dragonSuit}  |  T : ${rdescData.tigerSuit}`,
      },
    };
  };

  const modalData = getModalData();
  const allResults = lastResults.length > 0 
    ? lastResults
    : data.map((res, idx) => ({ win: res === "D" ? "D" : res === "T" ? "T" : res, mid: null }));

  return (
    <>
      <div className="result-row dragon-tiger casino-last-results">
        {allResults.map((resultItem, index) => {
          const win = resultItem.win;
          const isDragon = win === "D" || win === "1";
          return (
            <div
              key={index}
              className={`result-circle ${isDragon ? "result-dragon" : "result-tiger"}`}
              onClick={() => resultItem.mid && handleResultClick(resultItem, index)}
              style={{ cursor: resultItem.mid ? 'pointer' : 'default' }}
            >
              {isDragon ? "D" : "T"}
            </div>
          );
        })}
      </div>

      {modalData && (
        <ResultModalLayout
          show={showModal}
          onHide={handleCloseModal}
          title="1 Day Dragon Tiger"
          roundId={modalData.roundId}
          matchTime={modalData.matchTime}
          loading={loading}
        >
          <div className="row">
            <div className="col-12">
              <h6 className="text-right">
                <b>Round Id :</b> {modalData.roundId}
              </h6>
              <div className="text-center luckyseven-img">
                {modalData.dragon?.card && (
                  <img src={modalData.dragon.card} alt="Dragon Card" />
                )}
                {modalData.tiger?.card && (
                  <img src={modalData.tiger.card} alt="Tiger Card" />
                )}
              </div>
              <div className="col-md-12 text-left">
                {modalData.resultDetails.winner && (
                  <p className="m-b-0 m-t-20">
                    <b>Winner:</b> {modalData.resultDetails.winner}
                  </p>
                )}
                <p className="m-b-0">
                  <b>Pair:</b> {modalData.resultDetails.pair || 'No'}
                </p>
                {modalData.resultDetails.oddEven && (
                  <p className="m-b-0">
                    <b>Odd/Even:</b> {modalData.resultDetails.oddEven}
                  </p>
                )}
                {modalData.resultDetails.color && (
                  <p className="m-b-0">
                    <b>Color:</b> {modalData.resultDetails.color}
                  </p>
                )}
                {modalData.resultDetails.suit && (
                  <p className="m-b-0">
                    <b>Suit:</b> {modalData.resultDetails.suit}
                  </p>
                )}
              </div>
            </div>
          </div>
        </ResultModalLayout>
      )}
    </>
  );
};

export default ResultDragonTiger6;

